import { apiAuth } from "../api";
import { BORGHI_TIMBRO, leggiPassaporto, PASSAPORTO_KEY } from "../components/passaporto/passaportoData";

/** Punti da timbri Passaporto del Custode (localStorage). */
export function localPassportPoints() {
  try {
    const stato = leggiPassaporto();
    let total = 0;
    for (const b of BORGHI_TIMBRO) {
      if (stato[b.slug]) total += Number(b.punti) || 0;
    }
    // Legacy key usata dalla navbar (solo conteggio timbri → stima 50 pt ciascuno)
    if (total === 0) {
      const raw = localStorage.getItem("6amico_passaporto_timbri");
      if (raw) {
        const parsed = JSON.parse(raw);
        const n = Array.isArray(parsed) ? parsed.length : typeof parsed === "number" ? parsed : 0;
        total = n * 50;
      }
    }
    return total;
  } catch {
    return 0;
  }
}

/** Preferisci punti merito API; fallback ai timbri locali. */
export async function fetchCustodePoints() {
  const local = localPassportPoints();
  try {
    const { data } = await apiAuth.get("/punti/me");
    const apiPts = Number(data?.total_points);
    if (Number.isFinite(apiPts) && apiPts >= 0) {
      return Math.max(apiPts, local);
    }
  } catch {
    /* guest / offline */
  }
  return local;
}

export function firstNameFromUser(user) {
  if (!user) return "";
  const raw = (user.name || user.email || "").trim();
  if (!raw) return "Custode";
  const first = raw.split(/\s+/)[0];
  return first.includes("@") ? first.split("@")[0] : first;
}

export { PASSAPORTO_KEY };
